import { classNames } from "../utils/functions";
import { Link, useLocation } from "react-router-dom";

export default function MainMenu() {
  const location = useLocation();
  const pathname = location.pathname;

  const navigation = [
    { name: "Home", href: "/home" },
    { name: "Lookbook", href: "/lookbook" },
    { name: "Wardrobe", href: "/wardrobe" },
  ].map((item) => ({
    ...item,
    current: item.href !== "#" && item.href === pathname,
  }));

  return (
    <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
      {navigation.map((item) => (
        <Link
          key={item.name}
          to={item.href}
          className={classNames(
            item.current
              ? "border-indigo-500 text-gray-900 dark:text-gray-300"
              : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:hover:text-gray-400",
            "inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium"
          )}
          aria-current={item.current ? "page" : undefined}
        >
          {item.name}
        </Link>
      ))}
    </div>
  );
}
